module.exports = __webpack_public_path__ + "img/game-card-profile-icon-big.2919c050.png";